// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".lad-experiences{background-color:#ebeef2}.lad-experiences .swiper-wrapper .swiper-slide{width:220px}.lad-experiences .swiper-pagination{position:relative;margin-top:20px;bottom:inherit}.lad-experiences .section-header{padding:15px 0}.lad-experiences .section-title{text-align:center;margin-bottom:10px}.lad-experiences .section-description{text-align:center;text-transform:uppercase}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
